(function () {
  'use strict';

  var PHONE = '573167877345';
  var btn, countEl;

  function money(cents, currency) {
    var amount = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return '$' + amount;
  }

  function buildMessage(cart) {
    var lines = ['¡Hola! Quiero confirmar este pedido de DON:', ''];
    cart.items.forEach(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
      lines.push(item.quantity + 'x ' + item.product_title + variant + ' — ' + money(item.final_line_price, cart.currency));
    });
    lines.push('');
    lines.push('Total: ' + money(cart.total_price, cart.currency));
    lines.push('');
    lines.push('¿Confirmamos para recoger o domicilio y el método de pago?');
    return lines.join('\n');
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!btn) return;
        if (cart.item_count > 0) {
          btn.classList.add('is-visible');
          if (countEl) countEl.textContent = cart.item_count;
          btn.dataset.cart = JSON.stringify(cart);
        } else {
          btn.classList.remove('is-visible');
        }
      })
      .catch(function () {});
  }

  function onClick() {
    var raw = btn.dataset.cart;
    if (!raw) { refresh(); return; }
    var cart = JSON.parse(raw);
    if (!cart.items || !cart.items.length) return;
    var text = encodeURIComponent(buildMessage(cart));
    window.open('https://wa.me/' + PHONE + '?text=' + text, '_blank', 'noopener');
  }

  function init() {
    btn = document.querySelector('[data-radical-wa-fab]');
    if (!btn) return;
    countEl = btn.querySelector('.rdc-wa-fab__count');
    btn.addEventListener('click', onClick);
    document.addEventListener('cart:update', refresh);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();